import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import baseConfig from './config';
import Cookies from 'js-cookie';

/* 注入全局对象 */
window.__PMCAFF = {
    login: function(toUrl) {
    	const reloadUrl = toUrl || document.location.href;
        if (baseConfig.isNewIOSApp()) {
            window.webkit.messageHandlers.PMLoginFormWeb.postMessage({ reloadUrl: reloadUrl });
        } else if (baseConfig.isNewAndroidApp()) {
            window.android.PMLoginFormWeb();
        } else {
            window.location.href = `${baseConfig.getPmUrl()}user/login`;
        }
    },
    logout: function() {
        if (baseConfig.isNewIOSApp()) {
            window.webkit.messageHandlers.PMLogoutFormWeb.postMessage({ placeholder: 'placeholder' });
        } else if (baseConfig.isNewAndroidApp()) {
            window.android.PMLogoutFormWeb();
        } else {
            Cookies.remove('_PMAUTH', {
                domain: baseConfig.getCookieDomain()
            });
            window.location.reload();
        }
    }
};

axios.interceptors.request.use(function(config) {
    if (baseConfig.auth) {
        config.headers.Authorization = 'Bearer ' + baseConfig.auth.token;
    }
    return config;
}, error => Promise.reject(error));

Vue.prototype.apiURL = baseConfig.getApiUrl();
Vue.prototype.axios = axios;

Vue.config.productionTip = false
new Vue({
    el: '#pmcaffHeader',
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js